import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BaseFormBlock from "../BaseFormBlock";
import ColorFaces from "../../../../assets/images/faces_color.png";
import "./style.scss";
import PropTypes from "prop-types";
import AnswerTitle from "../../../InsightQuestionnaireFormPage/components/AnswerTitle";

const ratingAnswers = [
  { score: 1, isActive: false, isHighlight: false },
  { score: 2, isActive: false, isHighlight: false },
  { score: 3, isActive: false, isHighlight: false },
  { score: 4, isActive: false, isHighlight: false },
  { score: 5, isActive: false, isHighlight: false },
  { score: 6, isActive: false, isHighlight: false },
  { score: 7, isActive: false, isHighlight: false },
  { score: 8, isActive: false, isHighlight: false },
  { score: 9, isActive: false, isHighlight: false },
  { score: 10, isActive: false, isHighlight: false },
];

export default function RatingAnswer({ title, name, question, number, value }) {
  RatingAnswer.propTypes = {
    value: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  };
  const [ratings, setRatings] = useState(() => ratingAnswers);
  const [partnerRatings, setPartnerRatings] = useState(() => ratingAnswers);
  const { t } = useTranslation();

  useEffect(() => {
    onSetRatings(setRatings, question.userAnswer?.value);
    onSetRatings(setPartnerRatings, question.partnerAnswer?.value);
  }, [question.partnerAnswer?.value, question.userAnswer?.value]);

  const onSetRatings = (setFunc, ratingScore) => {
    setFunc((prevState) =>
      prevState.map((rating) => ({
        ...rating,
        isActive: rating.score <= ratingScore,
      }))
    );
  };

  return (
    <BaseFormBlock>
      <div className="insight-rating-answer-both">
        <AnswerTitle title={title} number={number} />

        <div className="insight-rating-answer-both__answers">
          {question.userAnswer?.value ? (
            <div className="insight-rating-answer-both__rating-container">
              <div className="insight-rating-answer-both__label">
                {t("insight_questionnaire_form_page.myAnswer")}
              </div>
              <div className="insight-rating-answer-both__rating-wrapper">
                {ratings.map((rating) => {
                  return (
                    <div
                      data-score={rating.score}
                      key={rating.score}
                      className="insight-rating-answer-both__rate"
                      style={{
                        filter: `saturate(${rating.isActive ? 1 : 0})`,
                      }}
                    >
                      <img src={ColorFaces} alt="gray_faces" />
                      <div>{rating.score}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}

          {question.partnerAnswer?.value ? (
            <div className="insight-rating-answer-both__rating-container">
              <div className="insight-rating-answer-both__label">
                {t("insight_questionnaire_form_page.partnerAnswer")}
              </div>
              <div className="insight-rating-answer-both__rating-wrapper">
                {partnerRatings.map((rating) => {
                  return (
                    <div
                      data-score={rating.score}
                      key={rating.score}
                      className="insight-rating-answer-both__rate"
                      style={{
                        filter: `saturate(${rating.isActive ? 1 : 0})`,
                      }}
                    >
                      <img src={ColorFaces} alt="gray_faces" />
                      <div>{rating.score}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </BaseFormBlock>
  );
}
